'use strict';

/**
 * Filters
 *
 * Custom Filters to Be Used Across Modules
 *
 * @version 12.4.0 #756 MLIBJS-121 Add validation to export bytes for ES6 usage
 *          7.11.0 #531 Remove time filter from custom filters
 *          7.10.0 #522 Add time conversion functionality
 *          7.9.0 #522 Add time conversion functionality
 *          3.2.0 #260 View changes based on shop standards
 *          3.0.0 #236 Add Shared Functionality to Main Library (Order Admin Refactor)
 *          3.0.0 #248 Changes based on Attached Media Refactor
 *          2.2.0 #230 Add Shared Code to Main Library
 *
 * @author Ryan Sweeney <rsweeney@webduct.com>
 *
 * @copyright (c) 2015-2016 Webduct Systems Inc.
 */
var bytes = angular.module('wd.filters', [])

    // Storage capacity with Measurement String
    .filter('bytes', function() {
        return function(bytes, precision) {
            if (isNaN(parseFloat(bytes)) || !isFinite(bytes)){ return '-'; }
            if (typeof precision === 'undefined') { precision = 1; }
            var units = ['bytes', 'kB', 'MB', 'GB', 'TB', 'PB'],
                number = Math.floor(Math.log(bytes) / Math.log(1024));
            return (bytes / Math.pow(1024, Math.floor(number))).toFixed(precision) +  ' ' + units[number];
        };
    })

    // Convert String to Uppercase
    .filter('capitalize', function() {
        return function(input) {
            return (!!input) ? input.charAt(0).toUpperCase() + input.substr(1) : '';
        };
    })

    // Weight with Measurement String
    .filter('weight', function() {
        return function(input) {
            return input ? input + ' lbs' : null;
        };
    });
if (typeof module !== 'undefined' && module.exports) {
    module.exports = bytes;
}    
// EOF
